import ReactDOM from "react-dom/client";

import App from "@/app/App";
import "@/styles/globals.scss";

const root = document.getElementById("venuex-root");

if (!root) {
  throw new Error("VenueX root not found.");
}

ReactDOM.createRoot(root).render(<App />);
